notifications-item
  notifications-items-common(tag-scope="{this.tagScope}")
  script(type="typescript").
    this.mixin('base');
